import { render } from "./MRoomSelectModal.vue?vue&type=template&id=16399978"
import script from "./MRoomSelectModal.vue?vue&type=script&lang=ts"
export * from "./MRoomSelectModal.vue?vue&type=script&lang=ts"
script.render = render

export default script